import React from 'react';
import { styled, SxProps, Typography } from '@mui/material';

const WhitespacePreservingTypography = styled(Typography)({
  whiteSpace: 'pre-wrap',
});

interface MessageDisplayProps {
  message?: string;
  variant?: 'body1' | 'body2' | 'body3';
  sx?: SxProps;
}

const MessageDisplay = ({
  message,
  variant = 'body3',
  sx,
}: MessageDisplayProps) => {
  if (!message) return null;

  return (
    <WhitespacePreservingTypography variant={variant} sx={sx}>
      {message}
    </WhitespacePreservingTypography>
  );
};

export default MessageDisplay;
